module.exports = __webpack_public_path__ + "img/instagram.b7725a23.svg";